import React from "react";
import { Link } from "react-router-dom";
import './BookCard.css'

const BookCard = (props) => {
  console.log(props.book);
  const {_id, bookName, authorName, price, image } = props.book;
  return (
    <div className="col-md-3 mb-3">
      <div className="m-3 shadow rounded p-3 h-100">
        <Link to={`/checkout/${_id}`}>
          <img className="img-fluid mb-4 w-80 text-center" src={image} alt="" />
          <div className="mb-4 bookCard-text">
            <h4>{bookName}</h4>
            <p>{authorName}</p>
          </div>
        </Link>

        <div className="d-flex justify-content-between">
          <h5>${price}</h5>
          <Link to={`/checkout/${_id}`}>
            <button className="btn btn-primary">Buy Now</button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BookCard;
